import React, { useState, useEffect, useContext } from "react";
import { useHistory } from "react-router-dom";
import { newlogin } from "../common/apiService";
import "./spinner.css";
import { apiEndPoint } from '../config';
import crypto from "crypto";
import { UserContext } from "../contexts/UserContext";
const { ssoUrl } = apiEndPoint;

export default function LoginPageNew() {
  const { setUserContext } = useContext(UserContext);
  const history = useHistory();

  const [loader, setLoader] = useState(false);

  useEffect(() => {
    loginNewPage();
  }, []);   

  function decrypt(encryptedMessage, secretKey) {
    const AES_CIPHER_ALGORITHM = "aes-256-cbc";
    const IV = Buffer.from(
      [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
      "utf8"
    );
    try {
      const decipher = crypto.createDecipheriv(
        AES_CIPHER_ALGORITHM,
        secretKey,
        IV
      );
      let decrypted = decipher.update(encryptedMessage, "base64", "utf8");

      decrypted += decipher.final("utf8");

      return decrypted;
    } catch (error) {
      console.log(" Error while decrypting:", error.toString());
    }
    return null;
  }

  function encryptUserId(userId, secretKey) {
    const AES_CIPHER_ALGORITHM = "aes-256-cbc";
    const IV = Buffer.from([
      0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
    ]);
  
    try {
      const cipher = crypto.createCipheriv(
        AES_CIPHER_ALGORITHM,
        secretKey,
        IV
      );
      let encrypted = cipher.update(userId.toString(), "utf8", "base64");
      encrypted += cipher.final("base64");
      return encrypted;
    } catch (error) {
      console.error("Error while encrypting:", error.toString());
    }  
    return null;
  }


  const loginNewPage = () => {
    setLoader(true);
    const Http = new XMLHttpRequest();
    Http.open("GET",ssoUrl+"/getSSOLoggedInDetails",true);
    Http.withCredentials = true;
    Http.send(null);
    Http.onreadystatechange = (e) => {
      if (Http.readyState === 4) {
        if (Http.status === 200 && Http.responseText.includes("userSessionDetails")) {

          const data = JSON.parse(Http.responseText || "{}");
          if (data.userSessionDetails?.userId) {
            const secretKeyBase64 = "rV3ECy9h/J241s/t4iwOUX1e397lDQegIgvhz+Je82s=";
            const secretKey = Buffer.from(secretKeyBase64, "base64");
            const encryptedUserId = encryptUserId(data.userSessionDetails?.userId, secretKey);
            const json = {
              encryptedUserId,
            };
            newlogin(json)
              .then((res) => {
              let response = {};
              try {
                // const userDetail = Buffer.from(res.data, 'base64').toString("utf8");
                const secretKeyBase64 =
                  "rV3ECy9h/J241s/t4iwOUX1e397lDQegIgvhz+Je82s=";
                const secretKey = Buffer.from(secretKeyBase64, "base64");
                const decrypteduserDetail = decrypt(res.data, secretKey);
                response = JSON.parse(decrypteduserDetail);
              } catch (error){
              console.log(" newlogin exception ",error.toString());
                response = { userType: "", username: "", roles: [],plazaId:[] };
              }

                const { roles, username, userType, plazaId } = response;

                setUserContext({
                  username: username,
                  roles: roles,
                  plaza: plazaId || "",
                  userType: userType,
                });

                setLoader(false);
                history.push("/dashboard");
              })
              .catch((err) => {
              console.log(" newlogin error : ",err.toString() );
                setLoader(false);
              });
          } else {
            setLoader(false);
            window.open(ssoUrl+"/login","_self");
          }
        } else  {
          setLoader(false);

          window.open(ssoUrl+"/login","_self");
        }
      }
    };
  };

  return (
    loader && (
      <div className="page-wrappper" data-testid="page-wrapper">
        <div className="loader1">
          <div className="dot"></div>
          <div className="dot"></div>
          <div className="dot"></div>
          <div className="dot"></div>
          <div className="dot"></div>
        </div>
      </div>
    )
  );
}
